import { render, staticRenderFns } from "./tabCrmCustomer.vue?vue&type=template&id=643897ee&scoped=true&"
import script from "./tabCrmCustomer.vue?vue&type=script&lang=js&"
export * from "./tabCrmCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643897ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643897ee')) {
      api.createRecord('643897ee', component.options)
    } else {
      api.reload('643897ee', component.options)
    }
    module.hot.accept("./tabCrmCustomer.vue?vue&type=template&id=643897ee&scoped=true&", function () {
      api.rerender('643897ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/crm/tabs/tabCrmCustomer.vue"
export default component.exports